export const useCheckboxStyles = ({
  isDisabled
}) => {
  const wrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    opacity: isDisabled ? 0.6 : 1
  };
  return {
    wrapperStyle
  };
};